import React, { Component } from 'react';
import './css/index.css';
import Header from './components/header';
import Main from './components/main';
import FooterComponent from './components/footer';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Header/>
        <Main/>
        <FooterComponent/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js